import { render, staticRenderFns } from "./InsuranceTable.vue?vue&type=template&id=5e32dfef"
import script from "./InsuranceTable.vue?vue&type=script&lang=js"
export * from "./InsuranceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports